import { FormControl, FormGroup } from "@angular/forms";
import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";

import { FormSearchParametersModel } from "../models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            pageId: new FormControl<number>(initialSearchParams.pageId),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            location: new FormControl<string>(initialSearchParams.location),
            facilities: new FormControl<Array<string>>(initialSearchParams.facilities),
            capacity: new FormControl<Array<number>>([initialSearchParams.minCapacity, initialSearchParams.maxCapacity])
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get pageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageId")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }
    public get location(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("location")) as FormControl<string>; }
    public get facilities(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("facilities")) as FormControl<Array<string>>; }
    public get capacity(): FormControl<Array<number>> { return this.formInstance.get("capacity") as FormControl<Array<number>>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            location: this.initialFormState.location,
            facilities: this.initialFormState.facilities,
            minCapacity: this.initialFormState.minCapacity,
            maxCapacity: this.initialFormState.maxCapacity
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText,
            minCapacity: this.capacity.value[0],
            maxCapacity: this.capacity.value[1]
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1,
            location: this.initialFormState.location,
            facilities: this.initialFormState.facilities,
            minCapacity: this.initialFormState.minCapacity,
            maxCapacity: this.initialFormState.maxCapacity
        });
    }
}
